<script setup lang="ts">
import { RouterLink, useRouter } from 'vue-router';
import { useAuthStore } from '../../stores/auth';

const auth = useAuthStore();
const router = useRouter();

async function handleLogout() {
  await auth.logout();
  router.push('/login');
}
</script>

<template>
  <header class="bg-asat text-white shadow-md">
    <div class="container mx-auto flex items-center justify-between h-14 px-4">
      <RouterLink to="/" class="flex items-center gap-2.5 hover:opacity-90">
        <img src="/logos/asat_logo_only_white.svg" alt="ASAT" class="h-5 -mt-0.5 mr-[-10px]" />
        <span class="w-[2px] h-7 bg-white/50 hidden sm:block" />
        <span class="text-base font-medium tracking-wide hidden sm:inline leading-none ml-[3px]">Sound Designer</span>
      </RouterLink>

      <nav v-if="auth.isAuthenticated" class="flex items-center gap-4 text-sm">
        <RouterLink
          to="/"
          class="hover:text-white/80 transition-colors"
          active-class="underline underline-offset-4"
        >
          Projects
        </RouterLink>
        <RouterLink
          v-if="auth.isAdmin"
          to="/admin/users"
          class="hover:text-white/80 transition-colors"
          active-class="underline underline-offset-4"
        >
          Users
        </RouterLink>
        <RouterLink
          v-if="auth.isAdmin"
          to="/admin/activity"
          class="hover:text-white/80 transition-colors"
          active-class="underline underline-offset-4"
        >
          Activity
        </RouterLink>
        <RouterLink
          v-if="auth.isAdmin"
          to="/admin/simulator"
          class="hover:text-white/80 transition-colors"
          active-class="underline underline-offset-4"
        >
          Simulator
        </RouterLink>
        <RouterLink
          v-if="auth.isAdmin"
          to="/admin/feature-flags"
          class="hover:text-white/80 transition-colors"
          active-class="underline underline-offset-4"
        >
          Flags
        </RouterLink>
        <RouterLink
          v-if="auth.isAdmin"
          to="/admin/kernel-versions"
          class="hover:text-white/80 transition-colors"
          active-class="underline underline-offset-4"
        >
          Kernels
        </RouterLink>

        <div class="flex items-center gap-2 ml-4 pl-4 border-l border-white/20">
          <span class="text-xs text-white/70 hidden md:inline">
            {{ auth.user?.email }}
          </span>
          <button
            class="text-xs bg-white/10 hover:bg-white/20 px-2 py-1 rounded transition-colors"
            @click="handleLogout"
          >
            Sign out
          </button>
        </div>
      </nav>
    </div>
  </header>
</template>
